// General
import React, { Component } from 'react';

// Redux Form
import { Field, reduxForm, formValueSelector } from 'redux-form';
import validate from './validate';

// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './AdminRolesForm.css';
import bt from '../../../components/commonStyle.css';
import {
  Button,
  FormGroup,
  FormControl,
  Col,
  Row,
} from 'react-bootstrap';

// Internal Components
import CustomCheckbox from '../../CustomCheckbox';
import { createAdminRole } from '../../../actions/siteadmin/AdminRoles/manageAdminRoles';

class AdminRolesForm extends Component {

  constructor(props) {
    super(props);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={cx(s.space5, 'positionRelative', s.spaceTop3)}>
        <label className={'inputLabel'}>{label}</label>
        <FormControl {...input} type={type} className={className} />
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
      </FormGroup>
    )
  }

  renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={cx(s.space5, 'positionRelative')}>
        <label className={'inputLabel'}>{label}</label>
        <FormControl
          {...input}
          className={className}
          componentClass="textarea"
          as="textarea"
          row="4"
        >
          {children}
        </FormControl>
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
      </FormGroup>
    );
  }

  renderCheckbox = ({ input, label, meta: { touched, error }, options, className }) => {
    const { formatMessage } = this.props.intl;
    let currentValue = input.value || [];

    return (
      <div>
        {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
        <Row>
          {
            options && options.length > 0 && options.map((option, index) => {
              return (
                <Col lg={6} md={6} key={index} className={className}>
                    <div className={cx(s.space2, 'privilagesOptionsRTL')}>
                      <div className={cx(s.tableCell, s.checkBoxWidth)}>
                        <CustomCheckbox
                          {...input}
                          className={'icheckbox_square-green'}
                          value={option.id}
                          name={`${input.name}[${index}]`}
                          checked={currentValue.indexOf(option.id) !== -1}
                          onChange={(event) => {
                            const newValue = [...currentValue] || [];
                            if (event === true) {
                              newValue.push(option.id);
                            } else {
                              newValue.splice(newValue.indexOf(option.id), 1);
                            }
                            return input.onChange(newValue);
                          }}
                        />
                      </div>
                      <div className={cx(s.tableCell, s.textWidth)}>
                        {' ' + option.privilege}
                      </div>
                    </div>
                </Col>
              )
            })
          }
        </Row>
      </div>
    );
  }

  async handleFormSubmit(values) {
    const { createAdminRole, paginationData } = this.props;
    const response = await createAdminRole(
      values.id,
      values.name,
      values.description,
      values.privileges
    );
    if (response && response.status === 200) {
      paginationData(1);
    }
  }

  render() {
    const { error, handleSubmit, submitting, id, privileges } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.formMaxWidth, 'maxwidthcenter', 'empty')}>
        <form onSubmit={handleSubmit(this.handleFormSubmit)}>
          {error && <strong>{formatMessage(error)}</strong>}
            <Field
              name="name"
              type="text"
              component={this.renderFormControl}
              label={formatMessage(messages.roleNameLabel)}
              className={s.formControlInput}
            />
            <Field
              name="description"
              component={this.renderFormControlTextArea}
              label={formatMessage(messages.descriptionAdminLabel)}
            />
          <FormGroup className={s.space3}>
            <label className={s.labelTextNew}><FormattedMessage {...messages.privilagesLabel} /></label>
            <Field
              name="privileges"
              component={this.renderCheckbox}
              options={privileges}
            />
          </FormGroup>
          <FormGroup className={s.formGroup}>
            <div className={cx(bt.textAlignRight, 'textAlignLeftRTL')}>
              <Button className={cx(s.button, s.btnPrimary)} type="submit" disabled={submitting}>
                {id ? <FormattedMessage {...messages.update} /> : <FormattedMessage {...messages.addLabel} />}
              </Button>
            </div>
          </FormGroup>
        </form>
      </div>
    )
  }

}

AdminRolesForm = reduxForm({
  form: "AdminRolesForm", // a unique name for this form
  validate,
})(AdminRolesForm);

const selector = formValueSelector('AdminRolesForm');

const mapState = (state) => ({
  id: selector(state, 'id'),
  privileges: state.commonSettings.privileges
});

const mapDispatch = {
  createAdminRole
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(AdminRolesForm)));